/**
 * Create a 16 character long numeric hash from a string.
 * Given the same input it will also return the same hash.
 * Here, it may be useful to convert a string that may have different lengths,
 * especially big ones, to a short identifier.
 * The seed can be used to create different hashes from the same input.
 * @param str The string to be hashed.
 * @param seed The seed to be used to create different hashes from the same input.
 * @returns The 16 character long numeric hash.
 */

export const getCyrb53 = (str: string, seed = 0): number => {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
